import React from 'react'
import { Box } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'
import { muiGrey } from 'src/style/muiTheme'

export const NoEmbroidery: React.FC = () => {
  const { t } = useLocale()
  return (
    <>
      <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
        {t.EMBROIDERY_ITEMS}
      </Box>
      {t.NO_EMBROIDERY}
    </>
  )
}
